import React, { useState, useEffect } from 'react'
import { Table, IconButton, Icon, Panel, ButtonGroup, Row, Col, Input } from 'rsuite'

import SearchButton from '../../components/buttons/searchButton/SearchButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { budgetFormat } from '../../utils/formatterUtil'
import '../../widgets/projectBasedItemsWidget/styles_table.less'

export default function UpdateListVoucherListTable({
  schema,
  loading,
  onSelect = () => {},
  onSearch = () => {},
  onDelete = () => {},
  onPreview = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const [documentNumber, setDocumentNumber] = useState('')
  const [description, setDescription] = useState('')

  useEffect(() => {
    setTableData(schema.values || [])
  }, [schema])

  const handleSearch = () => {
    // console.log('handleSearch ')
    var request = {
      documentNumber: documentNumber,
      description: description,
    }
    onSearch(request)
  }

  const handleCancel = () => {
    setDocumentNumber('')
    setDescription('')
    onSearch({})
  }

  // console.log('tableData ', tableData)

  return (
    <>
      <Panel header={'ค้นหา'} bordered defaultExpanded collapsible>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.documentNumber.label}
            <Input
              value={documentNumber}
              onChange={(value) => {
                setDocumentNumber(value)
              }}
            />
          </Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.description.label}
            <Input
              value={description}
              onChange={(value) => {
                setDescription(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginBottom: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <SearchButton disabled={false} onClick={handleSearch}>
              ค้นหา
            </SearchButton>
            {`  `}
            <CancelButton disabled={false} onClick={handleCancel}>
              ยกเลิก
            </CancelButton>
          </Col>
        </Row>
      </Panel>

      {schema?.isEnableEdit && (
        <div style={{ marginTop: 20 }}>
          <Row>
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <SaveButton
                icon="plus-square"
                disabled={false}
                onClick={() => {
                  onSelect(null, 'edit')
                }}
                style={{
                  marginRight: 10,
                }}
              >
                เพิ่มบันทึกปรับปรุงรายการ
              </SaveButton>
            </Col>
          </Row>
        </div>
      )}

      <div className="table-affix-header">
        <Table
          wordWrap
          minHeight={350}
          autoHeight
          loading={loading}
          data={tableData}
          style={{ marginTop: 10 }}
          rowClassName={(rowData) => (rowData && rowData.isSaveDraft ? 'saved-row' : '')}
          affixHeader
        >
          <Column width={90} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={150} align="center">
            <HeaderCell>วันที่เอกสาร</HeaderCell>
            <Cell dataKey="documentDate" />
          </Column>

          <Column width={150} align="center">
            <HeaderCell>เลขที่ใบสำคัญ</HeaderCell>
            <Cell dataKey="documentNumber" />
          </Column>

          <Column minWidth={300} width={420} flexGrow={1}>
            <HeaderCell>คำอธิบายรายการ</HeaderCell>
            <Cell dataKey="description" />
          </Column>

          <Column width={200} align="right">
            <HeaderCell>จำนวนเงิน (บาท)</HeaderCell>
            <Cell style={{ textAlign: 'right' }}>
              {(rowData) => {
                return budgetFormat(rowData.amount || 0)
              }}
            </Cell>
          </Column>

          <Column width={180} align="center">
            <HeaderCell>วันที่บันทึกรายการ</HeaderCell>
            <Cell dataKey="createDate" />
          </Column>

          <Column width={130} align="center" fixed="right">
            <HeaderCell>จัดการ</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-df"
                        size="sm"
                        icon={<Icon icon="eye" className="bt-gost-icon-none-radius" />}
                        onClick={(e) => {
                          onSelect(rowData, 'view')
                        }}
                      ></IconButton>
                      {schema?.isEnableEdit && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-edit"
                          size="sm"
                          icon={<Icon icon="edit" className="bt-gost-icon-none-radius-edit" />}
                          onClick={(e) => {
                            onSelect(rowData, 'edit')
                          }}
                        ></IconButton>
                      )}
                      {schema?.isEnableDelete && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          size="sm"
                          icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                          onClick={(e) => {
                            onDelete(rowData)
                          }}
                        ></IconButton>
                      )}
                      {!rowData.isSaveDraft && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-info"
                          size="sm"
                          //disabled={!rowData.pathFile}
                          icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
                          onClick={() => onPreview(rowData)}
                        ></IconButton>
                      )}
                    </ButtonGroup>
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </div>
    </>
  )
}
